// TODO: id-entityの方に持っていきたい
import { Organization as KaizenIdOrganization } from '@kaizenplatform/kaizen-id-entity';

import Permission from './Permission';
import Tag from './Tag';

export enum PermissionAction {
  MEMBERSHIPS_READ = 'MEMBERSHIPS_READ',
  MEMBERSHIPS_WRITE = 'MEMBERSHIPS_WRITE',
  ORGANIZATIONS_READ = 'ORGANIZATIONS_READ',
  ORGANIZATIONS_WRITE = 'ORGANIZATIONS_WRITE',
}

const AVAILABLE_PERMISSION_ACTION = Object.keys(PermissionAction);

export enum BusinessRegion {
  JAPAN = 'japan',
  UNITED_STATES = 'united_states',
  GLOBAL = 'global',
}

type BusinessRegionKey = keyof typeof BusinessRegion;

const AVAILABLE_BUSINESS_REGION: BusinessRegion[] = Object.keys(BusinessRegion).map(
  (k: string) => BusinessRegion[k as BusinessRegionKey],
);

class Organization extends KaizenIdOrganization {
  public readonly comment: string | null;
  public readonly permissions: Permission<PermissionAction>[];
  public readonly appVersion: number;
  public readonly tags: Tag[];
  public readonly isChildren: boolean;
  public readonly businessRegion: BusinessRegion;
  constructor({
    id,
    name,
    comment,
    profileImageUrl,
    permissions,
    appVersion,
    tags,
    isChildren,
    businessRegion,
  }: Pick<KaizenIdOrganization, 'id' | 'name' | 'profileImageUrl'> & {
    comment: string;
    permissions: Permission<PermissionAction>[];
    appVersion: number;
    tags: Tag[];
    isChildren: boolean;
    businessRegion: BusinessRegion;
  }) {
    super({ id, name, profileImageUrl });
    this.comment = comment;
    this.permissions = permissions;
    this.appVersion = appVersion;
    this.tags = tags;
    this.isChildren = isChildren;
    this.businessRegion = businessRegion;
  }

  public hasPermission = (pa: PermissionAction) => {
    const pp = this.permissions.find((p: Permission<PermissionAction>) => p.action === pa);
    return pp && pp.permission;
  };

  // NOTE: 最終的には分離されるが、現在はaccountとしてのorgを識別する必要がある
  public isAccount = (): boolean => {
    return this.appVersion === 1 && !this.isChildren;
  };

  public static fromJSON = (value: any) => {
    const {
      id,
      name,
      comment,
      profileImageUrl,
      permissions,
      appVersion,
      tags,
      isChildren,
      businessRegion,
    } = Object.assign({}, value);

    if (typeof id !== 'string') throw new TypeError('.id must be a string');
    if (typeof name !== 'string') throw new TypeError('.name must be a string');
    if (typeof profileImageUrl !== 'string') throw new TypeError('.profileImageUrl must be a string');
    if (typeof permissions !== 'object') throw new TypeError('.permissions must be an object');
    if (typeof appVersion !== 'number') throw new TypeError('.appVersion must be a number');
    if (typeof isChildren !== 'boolean') throw new TypeError('.isChildren must be a boolean');
    if (businessRegion && !AVAILABLE_BUSINESS_REGION.includes(businessRegion))
      throw new TypeError('.businessRegion must be a valid string');

    return new Organization({
      id,
      name,
      comment,
      profileImageUrl,
      permissions: permissions.map((p: any) => Permission.fromJSON(p, AVAILABLE_PERMISSION_ACTION)),
      appVersion,
      tags: tags.map((tag: any) => Tag.fromJSON(tag)),
      isChildren,
      businessRegion,
    });
  };
}

export default Organization;
